<div
  id="{{ uid }}"
  style="width: 100%; height: 100%; overflow: hidden"></div>
